import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickDelete } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberAcademicDegree } from "./routeType";

const { key, getPath } = getApi("members.academicDegree.delete");

type IExtractedRouteType =
  IMemberAcademicDegree["memberAcademicDegreeSingleDelete"];

export type IDeleteMemberAcademicGroup = IPickDelete<IExtractedRouteType>;

const deleteMemberAcademicGroup: Fetcher<
  IDeleteMemberAcademicGroup["response"],
  IDeleteMemberAcademicGroup["variables"]
> = ({ memberId, academicDegreeId }) => {
  return axiosClient.delete(getPath({ memberId, academicDegreeId }));
};

export const useDeleteMemberAcademicGroup = createQuery({
  queryKey: [key],
  fetcher: deleteMemberAcademicGroup,
});
